import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { mapDictionary } from '../lib/mapDictionary';
import type {
  PledgeEstateFormEntityReducer,
  TPledgeEstateFormIncomingDictionaries,
  TPledgeEstateFields,
} from '../types';

import { PledgeEstateValidationSchema } from './pledgeEstateForm.validationSchema';

// Выбираемые значения должны быть null, чтобы при стирании они менялись на undefined и становились dirty
const initialState: PledgeEstateFormEntityReducer = {
  data: null,
  defaults: {
    pledgeEstateAddress: null,
    pledgeEstateAddressFlat: '',
    isOnlyOwner: false,
    otherOwnerFullName: null,
    otherOwnerPhone: '',
    otherOwnerMaritalStatus: null,
    relationship: null,
    isPledgeAddressSameRegistration: false,
  },
  dictionaries: {
    otherOwnerRelationship: [],
    maritalStatuses: [],
  },
  isFullFilled: false,
  isActive: true,
  isOpenedInPopup: false,
};

export const pledgeEstateFormSlice = createSlice({
  name: 'pledgeEstateForm',
  initialState,
  reducers: {
    setPledgeEstateFormDictionaries: (
      state,
      { payload }: PayloadAction<Partial<TPledgeEstateFormIncomingDictionaries>>,
    ) => {
      const { otherOwnerRelationship, maritalStatuses } = mapDictionary(payload);

      return {
        ...state,
        dictionaries: {
          maritalStatuses,
          otherOwnerRelationship,
        },
      };
    },
    setPledgeEstateInfo: (state, { payload }: PayloadAction<{ data: TPledgeEstateFields; isFullFilled?: boolean }>) => {
      state.data = { ...payload.data };
      state.isFullFilled =
        payload.isFullFilled !== undefined
          ? payload.isFullFilled
          : PledgeEstateValidationSchema().isValidSync(payload.data);
    },
  },
});

export const { setPledgeEstateFormDictionaries, setPledgeEstateInfo } = pledgeEstateFormSlice.actions;
